import { createSelector } from 'reselect';
import { getGuidedChecklistVariant } from '@eb/variants';

const getFeatureFlags = (state) => state.featureFlags || {};

const getIsMarketingToolsExperimentEnabled = createSelector(
    getFeatureFlags,
    getGuidedChecklistVariant,
    (
        { isMarketingToolsExperimentEnabled = false },
        guidedChecklistVariant = null,
    ) => (guidedChecklistVariant ? isMarketingToolsExperimentEnabled : false),
);

export { getFeatureFlags, getIsMarketingToolsExperimentEnabled };
